import { Map } from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';
import { actionTypes as actionTypes } from '../../../actions/Administration/MatSettingsPage/Dialogs/updateMaterialQplVersionDialogActions.js';

let defaultState = {
  loading: false,
  show: false,
  items: null,
  qplId: null,
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.UPDATE_MATERIAL_QPL_VERSION_DIALOG_SHOW:
      return state.set('items', action.payload?.materials)
                  .set('qplId', action.payload?.qplId)
                  .set('show',true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.UPDATE_MATERIAL_QPL_VERSION_DIALOG, defaultState);
  }

}
